import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  MissingRequiredFieldsInfo,
  MissingField,
} from "../../model/missing-field";
import { MissingFieldsDialogData } from "./missing-required-fields-dialog-data";

@Component({
  selector: "im-missing-required-fields",
  templateUrl: "./missing-required-fields.component.html",
  styleUrls: ["./missing-required-fields.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MissingRequiredFieldsComponent implements OnInit {
  public isLoading: boolean = true;
  public missingItemsRequiredFields: MissingRequiredFieldsInfo[] = [];
  public missingSowRequiredFields: MissingRequiredFieldsInfo[] = [];
  private readonly message: string =
    "There are mandatory fields pending to be filled. Please, fill them before finishing the inspection.";

  constructor(
    private dialogRef: MatDialogRef<MissingRequiredFieldsComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: MissingFieldsDialogData,
  ) {}

  async ngOnInit(): Promise<void> {
    this.processInvalidFields(this.dialogData.missingRequiredFields);
  }

  public onClick(): void {
    this.dialogRef.close();
  }

  public getMessage(): string {
    return this.message;
  }

  private processInvalidFields(invalidFields: MissingField[]): void {
    const invalidItemsFields = invalidFields.filter(
      (invalidField) => invalidField.itemName != null,
    );
    const invalidSowFields = invalidFields.filter(
      (invalidFields) => invalidFields.itemName === undefined,
    );

    if (invalidItemsFields?.length) {
      this.missingItemsRequiredFields =
        this.processInvalidItemFields(invalidItemsFields);
    }
    if (invalidSowFields?.length) {
      this.missingSowRequiredFields =
        this.processInvalidSowFields(invalidSowFields);
    }
  }

  private processInvalidItemFields(
    invalidItemsFields: MissingField[],
  ): MissingRequiredFieldsInfo[] {
    const invalidItemFieldsGrouped = this.groupByItemName(invalidItemsFields);
    invalidItemFieldsGrouped.forEach((invalidItemField, i) => {
      invalidItemFieldsGrouped[i] = {
        item: invalidItemField[0].itemName,
        sections: this.groupBySectionName(invalidItemField as any),
      };
    });
    return invalidItemFieldsGrouped;
  }

  private processInvalidSowFields(
    invalidSowFields: MissingField[],
  ): MissingRequiredFieldsInfo[] {
    return [
      {
        item: null,
        sections: this.groupBySectionName(invalidSowFields as any),
      },
    ];
  }

  private groupByItemName(invalidItemsFields: MissingField[]): any[] {
    const groupedByItemName: Object = invalidItemsFields.reduce(
      (invalidItemsFields: any, invalidItemField) => {
        invalidItemsFields[invalidItemField.itemName] =
          invalidItemsFields[invalidItemField.itemName] || [];
        invalidItemsFields[invalidItemField.itemName].push(invalidItemField);
        return invalidItemsFields;
      },
      Object.create(null),
    );

    return Object.keys(groupedByItemName).map((index) => {
      return groupedByItemName[index];
    });
  }

  private groupBySectionName(invalidItemsFields: MissingField[]): any[] {
    const helper: any = {};
    return invalidItemsFields.reduce(
      (invalidItemsFields: any, invalidItemField) => {
        const key = invalidItemField.sectionName;
        if (!helper[key]) {
          helper[key] = Object.assign({}, { section: key, fields: [] });
          helper[key]["fields"].push(invalidItemField.fieldName);
          invalidItemsFields.push(helper[key]);
        } else helper[key]["fields"].push(invalidItemField.fieldName);
        return invalidItemsFields;
      },
      [],
    );
  }
}
